import script from "./CaptureAccounts.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptureAccounts.vue?vue&type=script&setup=true&lang=js"

import "./CaptureAccounts.vue?vue&type=style&index=0&id=bba57e72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba57e72"]])

export default __exports__